// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"
// import "./components/app"
import * as bootstrap from "bootstrap"
import "altcha"
import "altcha/i18n/en"
import "altcha/i18n/fr-fr"
import "altcha/i18n/nl"

globalThis.altchaI18n.set("fr-fr", {
  ...globalThis.altchaI18n.get("fr-fr"),
  label: "Je ne suis pas un robot",
});
